import { Typography } from '@mui/material'
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-premium'
import { NextRouter } from 'next/dist/shared/lib/router/router'
import { isDefined } from '@omnea-app/legacy/utils/type-guard/isDefined'
import { BaseColumnConfig } from '../types'
import { baseColumnConfig } from './baseColumnConfig'
import { HoverLinkWrapper } from './helpers/HoverLinkWrapper'
import type { GridValidRowModel } from '@mui/x-data-grid/models/gridRows'

type Dependencies = {
  push: NextRouter['push']
}

export type AgreementColumnConfig<T extends GridValidRowModel> = BaseColumnConfig<T, 'agreement'> & {
  columnType: 'agreement'
}

export const getAgreementColumn = <T extends GridValidRowModel>({
  dependencies: { push },
  style,
  ...config
}: AgreementColumnConfig<T> & { dependencies: Dependencies }): GridColDef<T> => ({
  ...baseColumnConfig,
  ...style,
  ...config,
  valueGetter: (_, row) => row.agreement?.name,
  renderCell: (params: GridRenderCellParams<T>) => {
    if (!isDefined(params.value)) return null
    return (
      <HoverLinkWrapper>
        <Typography
          variant="Body14pxRegular"
          sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
          onClick={(e) => {
            if (!isDefined(params.row.agreement?.id)) return
            e.stopPropagation()
            void push(`/agreements/detail/${params.row.agreement.id}`)
          }}
        >
          {params.value}
        </Typography>
      </HoverLinkWrapper>
    )
  },
})
